module.exports = __webpack_public_path__ + "img/social_image_instagram.71a9a0c.svg";